import { ChannelProfile, type Websocket } from 'entities/WebSocket'

export class ChannelsProfile {
  constructor(private _websocket: Websocket) {}

  subscribeChannels = (profile_id: number) => {
    new ChannelProfile(
      {
        id: profile_id,
      },
      this._websocket
    )
  }
}
